import { ServiceMaker, methods, services } from "../services";
import Api from '@/services/service-v2'

export const createSubscription = payload =>
  ServiceMaker(
    `/promo/promotion/create`,
    methods.POST,
    services.master,
    payload
  );

export const couponCodeList = payload =>
  ServiceMaker(
    `promo/promotion/get/user/tenant/all`,
    methods.GET,
    services.master
  );

export const editCouponcode = payload =>
  ServiceMaker(`/promo/promotion`, methods.PUT, services.master, payload);

export const deleteCouponcode = payload =>
  ServiceMaker(`/promo/promotion`, methods.DELETE, services.master, payload);

export const approveCouponcode = payload =>
  ServiceMaker(
    `/promo/promotion/approve`,
    methods.PUT,
    services.master,
    payload
  );

export const subscriptionList = payload =>
  ServiceMaker(
    `/subscription-payments/subscription`,
    methods.GET,
    services.master
  );

export const subscriptionAssign = payload =>
  ServiceMaker(
    `/subscription-payments/subscription/subscribe`,
    methods.POST,
    services.master,
    payload
  );

export const subscriptionListPartner = payload =>
  ServiceMaker(
    `subscription-payments/subscription/subscribed/${payload.id}`,
    methods.POST,
    services.master,
    payload.data
  );
export const subscriptionPartnerDelete = payload =>
  ServiceMaker(
    `subscription-payments/subscription/subscribed/cancel`,
    methods.DELETE,
    services.master,
    payload
  );

export const subscriptionSeller = () =>
  ServiceMaker("/subscription/my", methods.GET, services.subscribe);


export const createPaymentRequest = (method, payload) =>
  ServiceMaker(
    `/payments/request/${method}`,
    methods.POST,
    services.subscribe,
    payload
  );

export const verifyPaymentRequest = payload =>
  ServiceMaker(`/payments/verify`, methods.POST, services.subscribe, payload);


export const PaymentTransactionList = payload =>
  ServiceMaker(
    `/payments/transactions/list`,
    methods.POST,
    services.subscribe,
    payload
  );

export const getSubscriptionById = (id) => Api().$http.get(`/subscription-payments/subscription/subscriptionlist/${id}`)

export const getSubscriptionPlanbyFilter = (payload) => Api().$http.post(`/subscription-payments/subscription/filter`, payload)

